import { render, staticRenderFns } from "./KeywordSearch.vue?vue&type=template&id=461a3905&scoped=true"
import script from "./KeywordSearch.vue?vue&type=script&lang=js"
export * from "./KeywordSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461a3905",
  null
  
)

export default component.exports